import { render, staticRenderFns } from "./respostasPesquisas.vue?vue&type=template&id=2f2bcebe"
import script from "./respostasPesquisas.vue?vue&type=script&lang=js"
export * from "./respostasPesquisas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports